<template>
    <div class="footerCon">
        <div class="footerTextShow">
            <div class="main">
                <div class="footerItem clearfix">
                       <span class="ti">相关链接</span>
                       <div class="link">
                            <a href="javascript:void(0);">广东省工业协会</a>
                            <a href="javascript:void(0);">深圳赛瑞产业研究有限公司</a>
                            <a href="javascript:void(0);">国家新材料资源共享平台</a>
                            <a href="javascript:void(0);">新材料在线</a>
                       </div>
                 </div>
                 <div class="footerItem clearfix">
                       <span class="ti">版权所有</span>
                       <div class="companyShow">
                            <div class="item">
                                  <span class="name">广东省商务厅</span>
                                  <span>地址：广东省越秀区</span>
                                  <span>电话：23576677</span>
                                  <span>传真：23576677</span>
                            </div>
                            <div class="item">
                                  <span class="name">深圳市赛瑞产业研究有限公司</span>
                                  <span>地址：深圳市南山区</span>
                                  <span>电话：27557700</span>
                                  <span>传真：27557700</span>
                            </div>
                       </div>
                 </div>
            </div>
        </div>
        <div class="filinginfo">
            <div class="main">
                <span><a style="color:#FFF" href="https://beian.miit.gov.cn/">粤ICP备19162665号</a> </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>